/* IHMF a11y: make scrollable slideshow regions keyboard-accessible (WCAG 2.1.1).
   The theme sets tabindex="-1" on slideshow-slides, which axe flags as
   scrollable-region-focusable: keyboard users cannot scroll the card galleries.
   We set tabindex="0" on regions that actually scroll, and keep it applied via
   a MutationObserver because the theme re-renders these components. */
(function () {
  function scrollable(el) {
    var cs = getComputedStyle(el);
    var xScroll = (cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 1;
    var yScroll = (cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1;
    return xScroll || yScroll;
  }
  function fix(el) {
    if (scrollable(el) && el.getAttribute('tabindex') !== '0') {
      el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'group');
      if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', 'Image carousel');
    }
  }
  function apply() {
    document.querySelectorAll('slideshow-slides').forEach(fix);
  }
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes' && m.target.tagName === 'SLIDESHOW-SLIDES') {
        fix(m.target);
      }
    });
  });
  function start() {
    apply();
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['tabindex'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply);
  var tries = 0;
  var timer = setInterval(function () {
    apply();
    tries += 1;
    if (tries >= 10) clearInterval(timer);
  }, 800);
})();
